var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.breadCrumbs ? _c('v-breadcrumbs', {
          staticClass: "ml-n2 pt-2",
          attrs: {
            "items": _vm.breadCrumbs
          },
          scopedSlots: _vm._u([{
            key: "divider",
            fn: function fn() {
              return [_c('v-icon', [_vm._v("mdi-chevron-right")])];
            },
            proxy: true
          }], null, false, 3681283568)
        }) : _vm._e(), _vm.fleetId ? _c('table-wrapper', {
          attrs: {
            "headers": _vm.headers,
            "allItems": _vm.items,
            "loading": _vm.loading,
            "sortBy": "timestamp.created",
            "sortDesc": true
          },
          on: {
            "click:row": function clickRow(e) {
              return _vm.openDetail(e);
            }
          },
          scopedSlots: _vm._u([{
            key: "item.timestamp.created",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
            }
          }, {
            key: "item.accidentDetails.date",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [item.accidentDetails && item.accidentDetails.date ? _c('span', [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.accidentDetails.date)) + " ")]) : _vm._e()];
            }
          }, {
            key: "item.progressStatus",
            fn: function fn(_ref3) {
              var item = _ref3.item;
              return [_c('v-chip', {
                attrs: {
                  "small": "",
                  "color": _vm.colorByStatus.get(item.progressStatus)
                }
              }, [_vm._v(" " + _vm._s(_vm.$t("views.report.my.MyDamageView.status.".concat(item.progressStatus))) + " ")])];
            }
          }, {
            key: "item.numberplate",
            fn: function fn(_ref4) {
              var item = _ref4.item;
              return [_vm._v(" " + _vm._s(item.numberplate) + " ")];
            }
          }, {
            key: "item.tripType",
            fn: function fn(_ref5) {
              var item = _ref5.item;
              return [_vm._v(" " + _vm._s(_vm.$t("enums.TripTypeEnum.".concat(item.tripType))) + " ")];
            }
          }, {
            key: "item.damageType",
            fn: function fn(_ref6) {
              var item = _ref6.item;
              return [_vm._v(" " + _vm._s(_vm.$t("enums.DamageTypeEnum.".concat(item.damageType))) + " ")];
            }
          }, {
            key: "item.coverageType",
            fn: function fn(_ref7) {
              var item = _ref7.item;
              return [_vm._v(" " + _vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(item.coverageType))) + " ")];
            }
          }, {
            key: "item.damage",
            fn: function fn(_ref8) {
              var item = _ref8.item;
              return [_vm._v(" " + _vm._s(item.damage.map(function (damage) {
                return _vm.$t("components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.damages.".concat(damage));
              }).join(", ")) + " ")];
            }
          }, {
            key: "item.location",
            fn: function fn(_ref9) {
              var item = _ref9.item;
              return [item.location ? _c('span', [item.location.line2 ? _c('span', [_vm._v(_vm._s(item.location.line2) + ", ")]) : _vm._e(), item.location.street ? _c('span', [_vm._v(_vm._s(item.location.street) + ", ")]) : _vm._e(), item.location.zip || item.location.city ? _c('span', [_vm._v(_vm._s(item.location.zip) + " " + _vm._s(item.location.city))]) : _vm._e()]) : _vm._e()];
            }
          }], null, false, 1923749854)
        }) : _vm._e(), _vm.selectedId ? _c('my-damage-detail-side-card', {
          attrs: {
            "loading": _vm.loading
          },
          on: {
            "close": function close($event) {
              _vm.selectedId = null;
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }